// @flow
import { createSelector } from 'reselect';
import { fromJS } from 'immutable';

type AppSettings = typeof fromJS;
type Selector = any => AppSettings;

const getAllAppSettings = state => state.appSettings;
const getSettingKeyFromProps = (_, key) => key;

export const getAppSettings: Selector = createSelector(getAllAppSettings, settings => settings.get('settings'));
export const getAppSetting = createSelector(getAppSettings, getSettingKeyFromProps, (settings, key) =>
    settings.get(key)
);



// WEBPACK FOOTER //
// ./src/core/state/app-settings/selectors.js